"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RequestDialog = exports.ErrorDialog = exports.DialogSwitch = exports.DialogSelect = exports.DialogRow = exports.DialogInput = exports.DialogContent = exports.DialogCheckbox = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactIcons = require("@100mslive/react-icons");
var _reactUi = require("@100mslive/react-ui");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["Icon", "title", "closeable", "children", "css", "iconCSS"],
  _excluded2 = ["open", "onOpenChange", "title", "children"],
  _excluded3 = ["title", "options", "keyField", "labelField", "selected", "onChange"],
  _excluded4 = ["title", "value", "onChange", "placeholder", "disabled", "type"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var DialogContent = function DialogContent(_ref) {
  var Icon = _ref.Icon,
    title = _ref.title,
    _ref$closeable = _ref.closeable,
    closeable = _ref$closeable === void 0 ? true : _ref$closeable,
    children = _ref.children,
    css = _ref.css,
    _ref$iconCSS = _ref.iconCSS,
    iconCSS = _ref$iconCSS === void 0 ? {} : _ref$iconCSS,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Dialog.Portal, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Dialog.Overlay, {}), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Dialog.Content, _objectSpread(_objectSpread({
      css: _objectSpread({
        width: "min(600px, 100%)"
      }, css)
    }, props), {}, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Dialog.Title, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Flex, {
          justify: "between",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Flex, {
            align: "center",
            css: {
              mb: "$1"
            },
            children: [Icon ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Box, {
              css: _objectSpread({
                mr: "$2",
                color: "$textPrimary"
              }, iconCSS),
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(Icon, {})
            }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Text, {
              variant: "h6",
              inline: true,
              children: title
            })]
          }), closeable && /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Dialog.DefaultClose, {
            "data-testid": "dialoge_cross_icon"
          })]
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.HorizontalDivider, {
        css: {
          mt: "0.8rem"
        }
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Box, {
        children: children
      })]
    }))]
  });
};
exports.DialogContent = DialogContent;
var ErrorDialog = function ErrorDialog(_ref2) {
  var _ref2$open = _ref2.open,
    open = _ref2$open === void 0 ? true : _ref2$open,
    onOpenChange = _ref2.onOpenChange,
    title = _ref2.title,
    children = _ref2.children,
    props = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Dialog.Root, {
    open: open,
    onOpenChange: onOpenChange,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(DialogContent, _objectSpread(_objectSpread({
      Icon: _reactIcons.CrossIcon,
      title: title,
      onInteractOutside: function onInteractOutside(e) {
        return e.preventDefault();
      },
      onEscapeKeyDown: function onEscapeKeyDown(e) {
        return e.preventDefault();
      },
      onPointerDownOutside: function onPointerDownOutside(e) {
        return e.preventDefault();
      },
      closeable: false,
      iconCSS: {
        color: "$error"
      }
    }, props), {}, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Box, {
        css: {
          mt: "$lg"
        },
        children: children
      })
    }))
  });
};
exports.ErrorDialog = ErrorDialog;
var RequestDialog = function RequestDialog(_ref3) {
  var _ref3$open = _ref3.open,
    open = _ref3$open === void 0 ? true : _ref3$open,
    onOpenChange = _ref3.onOpenChange,
    title = _ref3.title,
    body = _ref3.body,
    _ref3$actionText = _ref3.actionText,
    actionText = _ref3$actionText === void 0 ? "Accept" : _ref3$actionText,
    onAction = _ref3.onAction,
    Icon = _ref3.Icon;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Dialog.Root, {
    open: open,
    onOpenChange: onOpenChange,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Dialog.Portal, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Dialog.Overlay, {}), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Dialog.Content, {
        css: {
          width: "min(400px,80%)",
          p: "$10"
        },
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Dialog.Title, {
          css: {
            p: 0,
            display: "flex",
            flexDirection: "row",
            gap: "$md"
          },
          children: [Icon ? Icon : null, /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Text, {
            variant: "h6",
            children: title
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Text, {
          variant: "md",
          css: {
            fontWeight: 400,
            mt: "$4",
            mb: "$10",
            c: "$textMedEmp"
          },
          children: body
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Flex, {
          justify: "center",
          align: "center",
          css: {
            width: "100%",
            gap: "$md"
          },
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Box, {
            css: {
              width: "50%"
            },
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Dialog.Close, {
              css: {
                width: "100%"
              },
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Button, {
                variant: "standard",
                outlined: true,
                css: {
                  width: "100%"
                },
                children: "Cancel"
              })
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Box, {
            css: {
              width: "50%"
            },
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Button, {
              variant: "primary",
              css: {
                width: "100%"
              },
              onClick: onAction,
              children: actionText
            })
          })]
        })]
      })]
    })
  });
};

/**
 * a row of items which breaks into column on small screen. For e.g. title on left and options to select
 * from on right for select component.
 */
exports.RequestDialog = RequestDialog;
var DialogRow = function DialogRow(_ref4) {
  var children = _ref4.children,
    _ref4$breakSm = _ref4.breakSm,
    breakSm = _ref4$breakSm === void 0 ? false : _ref4$breakSm,
    css = _ref4.css,
    _ref4$justify = _ref4.justify,
    justify = _ref4$justify === void 0 ? "between" : _ref4$justify;
  var finalCSS = {
    margin: "$10 0",
    w: "100%"
  };
  if (breakSm) {
    finalCSS["@sm"] = {
      flexDirection: "column",
      alignItems: "flex-start"
    };
  }
  if (css) {
    finalCSS = Object.assign(finalCSS, css);
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Flex, {
    align: "center",
    justify: justify,
    css: finalCSS,
    children: children
  });
};

/**
 * key field and label field are optional, option is directly used if not passed
 */
exports.DialogRow = DialogRow;
var DialogSelect = function DialogSelect(_ref5) {
  var title = _ref5.title,
    options = _ref5.options,
    keyField = _ref5.keyField,
    labelField = _ref5.labelField,
    selected = _ref5.selected,
    _onChange = _ref5.onChange,
    props = _objectWithoutProperties(_ref5, _excluded3);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(DialogRow, {
    breakSm: true,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Label, {
      children: title
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Select.Root, _objectSpread(_objectSpread({
      "data-testid": "dialog_select_".concat(title),
      css: {
        width: "70%",
        "@sm": {
          width: "100%"
        }
      }
    }, props), {}, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Select.DefaultDownIcon, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Select.Select, {
        onChange: function onChange(e) {
          return _onChange(e.target.value);
        },
        value: selected,
        css: {
          width: "100%"
        },
        children: options.map(function (option) {
          var id = keyField ? option[keyField] : option;
          var label = labelField ? option[labelField] : option;
          return /*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
            value: id,
            children: label
          }, id);
        })
      })]
    }))]
  });
};
exports.DialogSelect = DialogSelect;
var DialogInput = function DialogInput(_ref6) {
  var title = _ref6.title,
    value = _ref6.value,
    _onChange2 = _ref6.onChange,
    placeholder = _ref6.placeholder,
    disabled = _ref6.disabled,
    type = _ref6.type,
    props = _objectWithoutProperties(_ref6, _excluded4);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(DialogRow, {
    breakSm: true,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Label, {
      children: title
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Input, _objectSpread({
      css: {
        width: "70%",
        "@sm": {
          width: "100%"
        }
      },
      value: value,
      onChange: function onChange(e) {
        return _onChange2(e.target.value);
      },
      placeholder: placeholder,
      disabled: disabled,
      type: type
    }, props))]
  });
};
exports.DialogInput = DialogInput;
var DialogSwitch = function DialogSwitch(_ref7) {
  var title = _ref7.title,
    value = _ref7.value,
    onChange = _ref7.onChange,
    disabled = _ref7.disabled;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(DialogRow, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Text, {
      children: title
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Flex, {
      justify: "end",
      css: {
        width: "70%"
      },
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Switch, {
        checked: value,
        disabled: disabled,
        onCheckedChange: onChange
      })
    })]
  });
};
exports.DialogSwitch = DialogSwitch;
var DialogCheckbox = function DialogCheckbox(_ref8) {
  var title = _ref8.title,
    value = _ref8.value,
    onChange = _ref8.onChange,
    disabled = _ref8.disabled,
    css = _ref8.css,
    id = _ref8.id;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(DialogRow, {
    css: css,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Label, {
      htmlFor: id,
      css: {
        cursor: "pointer"
      },
      children: title
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Checkbox.Root, {
      checked: value,
      onCheckedChange: function onCheckedChange(value) {
        return onChange(value);
      },
      disabled: disabled,
      id: id,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Checkbox.Indicator, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.CheckIcon, {
          width: 16,
          height: 16
        })
      })
    })]
  });
};
exports.DialogCheckbox = DialogCheckbox;